let hydrationPayloadChecked = false;

export default async function fetchEmployeePublications(
	axios,
	publications,
	apiDomain
) {
	if (!publications?.endpointUrl) {
		return [];
	}
	const url = new URL(publications.endpointUrl, 'https://www.example.com/');
	for (const field of publications.fields || []) {
		url.searchParams.set(field.name, field.value ?? '');
	}
	const response = await axios
		.get(
			url.pathname + url.search,
			process.server && apiDomain ? { baseURL: apiDomain } : undefined
		)
		.catch(() => {
			console.error('Failed to fetch employee publications');
		});
	if (!Array.isArray(response.data?.groups)) {
		throw new Error('Invalid employee publications response');
	}
	return response.data.groups;
}

export function getHydratedEmployeePublications(component) {
	if (
		!process.client ||
		hydrationPayloadChecked ||
		component._employeePublicationsHydrationComplete
	) {
		return null;
	}
	hydrationPayloadChecked = true;

	const fetchPayload = window.__NUXT__?.fetch;
	const fetchKeys = [
		component.$el?.dataset?.fetchKey,
		component.$vnode?.elm?.dataset?.fetchKey,
		component._fetchKey,
		...Object.keys(fetchPayload || {}).filter((key) =>
			key.startsWith(`${component.$options.name}:`)
		),
	];
	const fetchData = fetchKeys
		.filter(Boolean)
		.map((key) => fetchPayload?.[key])
		.find((data) => Array.isArray(data?.groups));

	if (!fetchData) {
		return null;
	}

	component._employeePublicationsHydrationComplete = true;
	return fetchData.groups;
}
